export class RelatedItemsModel {
  constructor (
    public slide: object[],
    public title?: string
  ) {}
}

export class TimelineModel {
  constructor (
    public year: object[]
  ) {}
}

export class MultimediaModel {
  constructor (
    public idx: string,
    public url: string,
    public altText: string,
    public type?: string
  ) {}
}

export class ExternalLinkModel {
  constructor (
    public url: string
  ) {}
}

export class DocumentAttributesModel {
    constructor (
        public title?: string,
        public subtitle?: string,
        public goid: string = null,
        public sourceType?: string,
        public durableUrl: string = '',
        public pubTitle?: string,
        public author?: string,
        public recordType: string = '',
        public sourceRollUpType?: string,
        public pubDate?: string,
        public language?: string,
        public edition?: string,
        public lexileScore?: string,
        public volume?: string,
        public issue?: string,
        public pagination?: string,
        public copyright?: string,
        public hasPdf: boolean = false,
        public text?: string,
        public abstract?: string,
        public section?: object[],
        public heroImg?: string,
        public docLink?: object[],
        public isHeroImgLandscape: boolean = false,
        public isRTDoc: boolean = false,
        public hasAudio?: boolean,
        public image?: string,
        public downloadImage?: string,
        public multimediaConfig?: MultimediaModel,
        public id: string = null,
        public externalLink?: ExternalLinkModel,
        public parentId?: string,
        public thumbnailImage?: object,
        public searchId?: string,
        public legacyID?: string,
        public hasVideo?: boolean,
        public pdfLinkContent?: string,
        public relatedItems: RelatedItemsModel = { slide: [] },
        public relatedSearches?: object[],
        public timeline: TimelineModel = { year: [] },
        public documentlinks?: object[],
        public hasCitation?: string | boolean,
        public pdfOnly?: boolean
    ) {}
}
